export default class topManager {
    constructor(effect) {

        this.kv = document.getElementById('p-kv');
        this.svg = document.getElementById('p-kv-logo-svg');
        this.svg1 = document.getElementById('p-kv-logo-svg1');
        this.svg2 = document.getElementById('p-kv-logo-svg2');
        this.svg3 = document.getElementById('p-kv-logo-svg3');
        this.text = document.getElementById('p-kv-text');
        this.image = document.getElementById('p-kv__image');
        this.bg = document.getElementById('p-kv__bg');

        this.logo = document.getElementById('l-header-title');

        this.body = document.getElementById('l-body');

        this.effect = effect;

        TweenMax.set(this.svg2,{
            y:5
        });
        TweenMax.set(this.image,{
            scale:0.99
        });
        TweenMax.set(this.body,{
            y:50
        });
        TweenMax.set(this.text,{
            opacity:1
        });

        let text = new SplitText(this.text, {type: "words,chars"}),
            chars = text.chars;
        this.text = chars;
        TweenMax.set(this.text, { y: '100%' });

        this.katakata = new TimelineMax({
            delay:1.6
        });

        this.katakataRepeat = new TimelineMax({
            delay: 1.2,
            repeatDelay: 2.2,
            repeat: -1
        });


    }
    init(){

        TweenMax.to(this.kv, 0.3 ,{
            opacity:1,
            ease: Sine.easeIn,
        });
        TweenMax.to(this.svg3, 0.5 ,{
            opacity:1,
            ease: Sine.easeIn,
        });
        TweenMax.to(this.svg1, 0.5 ,{
            opacity:1,
            ease: Sine.easeIn,
        });

        this.katakata.to(this.svg1, 0.25 ,{
            rotation: -3,
            y: -2,
            transformOrigin:"50% 50%",
            ease: Sine.easeIn,
        }).to(this.svg1, 0.15 ,{
            rotation: 1,
            y: 0,
            transformOrigin:"50% 50%",
            ease: Sine.easeIn,
        }).to(this.svg1, 0.2 ,{
            rotation: -1,
            y: 1,
            transformOrigin:"50% 50%",
            ease: Sine.easeIn,
        }).to(this.svg1, 0.3 ,{
            rotation: 0,
            y: 0,
            transformOrigin:"50% 50%",
            ease: Sine.easeIn,
        })

        TweenMax.set(this.svg, {delay:.23,className:"+=type-white"});
        TweenMax.to(this.svg2, 0.7 ,{
            delay:.25,
            opacity:1,
            y: 0,
            ease: Back.easeOut.config(1.7),
            onStart:() => {
                TweenMax.staggerTo(this.text, 0.7 ,{
                    delay:.05,
                    y: '0%',
                    ease: Back.easeOut.config(1)
                },0.02);
                TweenMax.to(this.bg, .3 ,{
                    delay:.15,
                    opacity:1,
                    ease: Power2.easeOut
                });
                TweenMax.to(this.image, 1.5 ,{
                    delay:.55,
                    opacity:1,
                    ease: Power2.easeOut
                });
                TweenMax.to(this.image, 2 ,{
                    delay:.55,
                    scale:1,
                    ease: Power0.easeOut
                });
                TweenMax.to(this.logo, .5 ,{
                    delay:.75,
                    opacity:1,
                    ease: Power2.easeOut,
                    onComplete:() => {
                        TweenMax.to(this.body, .6 , {
                            opacity: 1,
                            y: 0,
                            ease: Power1.easeOut,
                            // onComplete:() => {
                            //     this.repeat();
                            // }
                        });
                    }
                });
            }
        });

    }

    repeat(){

        this.katakataRepeat.to(this.svg1, 0.25 ,{
            rotation: -2,
            y: -2,
            transformOrigin:"50% 50%",
            ease: Sine.easeIn,
        }).to(this.svg1, 0.15 ,{
            rotation: 0,
            y: 1,
            transformOrigin:"50% 50%",
            ease: Sine.easeIn,
        }).to(this.svg1, 0.2 ,{
            rotation: 3,
            y: -1,
            transformOrigin:"50% 50%",
        }).to(this.svg1, 0.2 ,{
            rotation: 0,
            y: 0,
            transformOrigin:"50% 50%",
            ease: Sine.easeIn,
        })
    }

    getRandom(max, min){
        return Math.floor(Math.random() * (1 + max - min) + min);
    }

    resize(_w,_h,_display){

        let _this = this;

    }

    modal(type){

    }

}